import Unit from '@leverege/unit';
import BooleanEditor from "./BooleanEditor.js";
import IntEditor from "./IntEditor.js";
import NumberEditor from "./NumberEditor.js";
import PercentEditor from "./PercentEditor.js";
import StringEditor from "./StringEditor.js";
import TimestampEditor from "./TimestampEditor.js";
import ToggleEditor from "./ToggleEditor.js";
import UnitEditor from "./UnitEditor.js";
import GeoPointEditor from "./GeoPointEditor.js";
import AddressEditor from "./AddressEditor.js";
import FormResourceEnumEditor from "./FormResourceEnumEditor.js";
import FormEnumEditor from "./FormEnumEditor.js";
import ValueUpdateEditor from "./ValueUpdateEditor.js";
import ImagineImageEditor from "./ImagineImageEditor/ImagineImageEditor.js";
import ImageEditor from "./ImageEditor/ImageEditor.js";
import StringArrayEditor from "./StringArrayEditor.js";
import IntArrayEditor from "./IntArrayEditor.js";
import NumberArrayEditor from "./NumberArrayEditor.js";
const install = molten => {
  molten.addPlugin('BlueprintAttributeFormEditor', BooleanEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', IntEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', NumberEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', PercentEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', StringEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', TimestampEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', ToggleEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', GeoPointEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', AddressEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', FormResourceEnumEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', FormEnumEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', ValueUpdateEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', ImagineImageEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', ImageEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', StringArrayEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', IntArrayEditor);
  molten.addPlugin('BlueprintAttributeFormEditor', NumberArrayEditor);
  const types = Unit.getUnitTypes();
  types.forEach(type => {
    molten.addPlugin('BlueprintAttributeFormEditor', {
      type,
      editor: UnitEditor
    });
  });
};
export default {
  install
};